import React, { useEffect } from 'react';
import Prism from 'prismjs';
import './pseudocode';  // Import the custom language definition
import 'prismjs/components/prism-verilog';  // SystemVerilog / Verilog highlighting
import 'prismjs/themes/prism.css';
import './codeblock.css'


const PseudocodeCodeBlock = ({ code, language }) => {
  useEffect(() => {
    Prism.highlightAll();
  }, []);

  return (

      <code className={`language-${language}`} id='codeblock'>
        {code}
      </code>

  );
};

export default PseudocodeCodeBlock;
